import { render, staticRenderFns } from "./CommissionDistributionRuleSetSelect.vue?vue&type=template&id=47e7c762"
import script from "./CommissionDistributionRuleSetSelect.vue?vue&type=script&lang=js"
export * from "./CommissionDistributionRuleSetSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports